export default "__VITE_ASSET__d84a9088__"